import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrganizations, addOrganization, updateOrganization } from '../../services/api/organizationService';

export const loadOrganizations = createAsyncThunk('organizations/load', async () => fetchOrganizations());
export const createOrganizationRecord = createAsyncThunk('organizations/create', async (payload) => addOrganization(payload));
export const updateOrganizationRecord = createAsyncThunk('organizations/update', async ({ id, changes }) => updateOrganization(id, changes));

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadOrganizations.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(loadOrganizations.fulfilled, (state, action) => { state.status = 'succeeded'; state.items = action.payload; })
      .addCase(loadOrganizations.rejected, (state, action) => { state.status = 'failed'; state.error = action.error.message; })
      .addMatcher((a) => [createOrganizationRecord.pending.type, updateOrganizationRecord.pending.type].includes(a.type), (state) => { state.mutationStatus = 'loading'; state.error = null; })
      .addCase(createOrganizationRecord.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; state.items.unshift(action.payload); })
      .addCase(updateOrganizationRecord.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; const i = state.items.findIndex((o) => o.id === action.payload.id); if (i >= 0) state.items[i] = action.payload; })
      .addMatcher((a) => [createOrganizationRecord.rejected.type, updateOrganizationRecord.rejected.type].includes(a.type), (state, action) => { state.mutationStatus = 'failed'; state.error = action.error.message; });
  }
});
export default organizationsSlice.reducer;
